import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { startChat } from '../lib/chat/startChat';
import { ComposerInput } from './ComposerInput';
/**
 * PromptComposer - Wrapper around ComposerInput for creating new chats
 *
 * This component handles the chat creation logic:
 * 1. Generates a new chat ID
 * 2. Stores initial prompt in sessionStorage
 * 3. Navigates to the chat page (ChatView will auto-send on mount)
 */ export function PromptComposer(props) {
    const navigate = useNavigate();
    const handleStartChat = async (data)=>{
        startChat(navigate, data.prompt, data.attachments);
    };
    return /*#__PURE__*/ _jsx(ComposerInput, {
        ...props,
        onSubmit: handleStartChat
    });
}
